import { useRef } from 'react';
import { Dialog } from '@headlessui/react';
import { Button, Icon } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';

import { useDispatch, useSelector } from 'react-redux';
import { extensionModel } from '../model';

import { modalMessages } from '../config';
import { ExtensionModalOptions } from './ExtensionModalOptions';

export const InstallExtensionModal = () => {
  const dispatch = useDispatch();

  const { isInstallModalOpen } = useSelector(
    extensionModel.selectors.selectExtension
  );

  const focusRef = useRef(null);

  const handleClose = () =>
    dispatch(extensionModel.actions.setIsInstallModalOpen(false));

  const handleInstall = () => {
    dispatch(extensionModel.actions.extensionInstallClick());
    handleClose();
  };

  return (
    <Dialog
      initialFocus={focusRef}
      className="relative z-50 w-full"
      open={isInstallModalOpen}
      onClose={handleClose}
    >
      <div className="fixed inset-0 flex items-center justify-center p-4 bg-bg-200">
        <Dialog.Panel className="w-full max-w-240 h-160 px-6 pt-10 pb-8 shadow-xl rounded-xl bg-base-white relative flex flex-col items-center overflow-hidden">
          <Icon
            glyph={IconMap.GoogleChromeColored}
            className="text-primary-700 self-center shrink-0"
            width={48}
          />
          <Dialog.Title className="text-gray-900 text-display-sm font-semibold font-display mt-4 mb-1 text-center">
            {modalMessages.title}
          </Dialog.Title>
          <p className="text-gray-600 text-md mb-6 text-center">
            {modalMessages.description}
          </p>
          <ExtensionModalOptions />
          <Button
            ref={focusRef}
            variant="text"
            color="primary-gradient"
            onClick={handleInstall}
            className="w-fit mb-2"
          >
            Install the Distribute Chrome Extension
            <Icon glyph={IconMap.ArrowRight} width={20} className="ml-1.5" />
          </Button>
          <Button
            variant="text"
            color="tertiary-black"
            onClick={handleClose}
            className="w-fit"
            size="md"
          >
            I'll do this later
          </Button>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};
